const passwordInputs = document.getElementsByClassName("password-input");
const passwordButtons = document.getElementsByClassName("password-input__btn");

if (passwordButtons.length === passwordInputs.length) {
  for (let i = 0; i < passwordButtons.length; i++) {
    passwordButtons[i].addEventListener("click", () => toggleInputType(i));
  }

  /**
   * Shows and hides password input
   * @param {number} buttonIndex - index of button clicked
   */
  function toggleInputType(buttonIndex) {
    const passwordInput = passwordInputs[buttonIndex];
    const passwordButton = passwordButtons[buttonIndex];

    const buttonTextElem = passwordButton.querySelector("span");
    const buttonIconPath = passwordButton.querySelector("use");

    if (passwordInput.type === "password") {
      buttonIconPath.setAttribute("xlink:href", "#closed-eye");
      buttonTextElem.innerHTML = "hide";
      passwordButton.setAttribute("aria-pressed", "true");
      passwordInput.type = "text";
    } else if (passwordInput.type === "text") {
      buttonIconPath.setAttribute("xlink:href", "#open-eye");
      buttonTextElem.innerHTML = "show";
      passwordButton.setAttribute("aria-pressed", "false");
      passwordInput.type = "password";
    }
  }
}
